import { useTranslation } from "react-i18next";
import fancyArrow from "../../../assets/fancyArrow.svg";

import "./index.scss";

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  ///@ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

export const BeginJourneySection = () => {
  const { t } = useTranslation();
  return (
    <div className="c-begin-journey-section">
      <div className="c-begin-journey-section__modal">
        <p className="c-begin-journey-section__modal-title">
          {t("presentationPage.begin")}
          {/* Begin your <br />
          journey with */}
          {/* <br />
          <span className="c-begin-journey-section__modal--highlight">
            Watugot
          </span> */}
        </p>
        <button className="c-begin-journey-section__modal-button">
          <div className="c-begin-journey-section__modal-button-content">
            <img alt="arrow" src={fancyArrow} />
            <a
              style={{ color: "white" }}
              href={
                getMobileOperatingSystem() === "iOS"
                  ? "https://apps.apple.com/us/app/pi-browser/id1560911608"
                  : "https://play.google.com/store/apps/details?id=pi.browser&hl=en&gl=US"
              }
              target="__blank"
            >
              {t("presentationPage.download")}
            </a>
          </div>
        </button>
      </div>
    </div>
  );
};
